import { getCargo } from '@pages/Basket/components/ServicesList/components/OrderList/components/OrderListItem/helpers';
import {
  ContainerParameters,
  CustomCargoParameters,
  RouteInGroup,
  RouteResult,
  TruckParameters,
} from '@services/requests/orderService/types';

/**
 * Получение описания для груза на основании типа груза и их параметров
 * @param cargoType
 * @param containerParameters
 * @param customCargoParameters
 * @param truckParameters
 * @param route
 */
export const getCargoParams = (
  cargoType: 'container' | 'custom' | 'truck',
  containerParameters: ContainerParameters[],
  customCargoParameters: CustomCargoParameters[],
  truckParameters: TruckParameters[],
  route: RouteInGroup
) => {
  switch (cargoType) {
    case 'container':
      return containerParameters.find((c) => c.identifier === route.cargoID);
    case 'custom':
      return customCargoParameters.find((c) => c.identifier === route.cargoID);
    case 'truck':
      return truckParameters.find((c) => c.identifier === route.cargoID);
  }
};

export const getCargoDescription = (
  realTimeBaseData,
  route: RouteResult,
  routeGroup: RouteInGroup,
  langCode?: string,
  langId?: string
) => {
  return getCargo(
    route.type,
    {
      containers: realTimeBaseData.containers,
      units: realTimeBaseData.units,
      trucks: realTimeBaseData.trucks,
    },
    {
      containers: [
        route.cargoParameters.containerParameters.find((i) => routeGroup.cargoID === i.identifier),
      ],
      customs: [
        route.cargoParameters.customCargoParameters.find(
          (i) => routeGroup.cargoID === i.identifier
        ),
      ],
      trucks: [
        route.cargoParameters.truckParameters.find((i) => routeGroup.cargoID === i.identifier),
      ],
    },
    langCode,
    langId
  ).join('; ');
};
